import { useEffect, useRef, useState } from "react";

import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridColumnMenuFilter,
  GridColumnMenuProps,
  GridDataStateChangeEvent,
  GridExpandChangeEvent,
  GridNoRecords,
} from "@progress/kendo-react-grid";

import {
  setExpandedState,
  setGroupIds,
} from "@progress/kendo-react-data-tools";
import { DataResult, process, State } from "@progress/kendo-data-query";
import { SubmitStatus } from "../../core/formik-model-dialog.component";
import { API_END_POINT } from "../../constants";
import { GridCommandCell } from "../../core/grid-command-cell.component";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import {
  DeleteModelDialog,
  DeletePostDataInfo,
  DeleteStatus,
} from "../../core/delete-model-dialog.component";
import SaleTypeModel from "../../models/masters/saletype-model";
import { useGetSaleTypes } from "../../apiclient/master/useGetSaleTypeApi";
import SaleTypeEntry from "./saletype-entry";

export const addOrUpdateArrayItem = (data: any[], item: any, key: string) => {
  const newData = data ? [...data] : [];
  const index = data?.findIndex((d) => d[key] === item[key]);
  console.log("the index is" + index);
  if (index > -1) {
    newData.splice(index, 1, item);
  } else {
    newData.push(item);
  }
  return newData;
};

const SaleTypePage: React.FC = () => {
  const initialDataState: State = {
    take: 10,
    skip: 0,
    group: [],
  };
  const [dataState, setDataState] = useState<State>(initialDataState);
  const [deleteSaleTypeData, setDeleteSaleTypeData] =
    useState<DeletePostDataInfo>();
  const [collapsedState, setCollapsedState] = useState<string[]>([]);
  const [resultData, setResultData] = useState<DataResult>();

  const [editModal, setEditModal] = useState<boolean>(false);
  const [editData, setEditdata] = useState<SaleTypeModel>(null);
  const exportExcel = useRef<ExcelExport | null>(null);

  const [pgreset, setpgreset] = useState<boolean>(false);

  const {
    data: result,
    isLoading,
    isError,
    refetch: reloadSaleType,
  } = useGetSaleTypes();

  const processWithGroups = (data: SaleTypeModel[], dataState: State) => {
    const groups = dataState.group;
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };

  useEffect(() => {
    setEditdata(null);
    if (result) {
      setResultData(processWithGroups(result, initialDataState));
    }
  }, [result]);

  let newData: any = null;
  if (resultData) {
    newData = setExpandedState({
      data: resultData.data,
      collapsedIds: collapsedState,
    });
  }

  const onSaveComplete = (status: SubmitStatus, data: SaleTypeModel) => {
    setEditdata(null);
    if (status === SubmitStatus.Completed) {
      reloadSaleType();
      setResultData(processWithGroups(newData, dataState));
    }
  };

  const excelExport = () => {
    if (exportExcel.current !== null) {
      exportExcel.current.save();
    }
  };

  const onAddNew = () => {
    setEditModal(true);
    setEditdata(new SaleTypeModel());
  };

  const onEdit = (data: SaleTypeModel) => {
    setEditModal(true);
    setEditdata(data);
  };

  const onRemove = (data: SaleTypeModel) => {
    const { saleTypeId } = data;
    setDeleteSaleTypeData({
      data,
      route: `SaleType/DeleteSaleType/${saleTypeId}`,
      endpoint: API_END_POINT.MASTER,
    });
    reloadSaleType();
  };
  const onDeleteComplete = (status: DeleteStatus, data: SaleTypeModel) => {
    if (status === DeleteStatus.Completed) {
      reloadSaleType();
      setResultData(processWithGroups(result, dataState));
    }
    setDeleteSaleTypeData(null);
  };
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const CommandCell = (props: GridCellProps) => (
    <GridCommandCell
      {...props}
      edit={onEdit}
      remove={onRemove}
      add={onAddNew}
      dataItem={props.dataItem}
      idPropertyName="saleTypeId"
      editPermissionName={null}
      deletePermissionName={null}
    />
  );

  const onSearch = (e: any) => {
    if (e.target.value.length > 0) {
      const searchKey: string = e.target.value;
      const filteredData = result?.filter((p) =>
        p?.name?.toLowerCase().includes(searchKey?.toLowerCase())
      );
      setResultData(process(filteredData, dataState));
    } else {
      setResultData(process(result, dataState));
    }
  };

  const expandChange = (event: GridExpandChangeEvent) => {
    const item = event.dataItem;

    if (item.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  const refreshGrid = () => {
    reloadSaleType();
  };
  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(result, event.dataState);
    setResultData(newDataState);
    setDataState(event.dataState);
  };

  let grid = null;
  if (result) {
    grid = (
      <Grid
        data={newData}
        pageable={{ pageSizes: [10, 20, 50, 100] }}
        total={resultData?.total}
        groupable={true}
        sortable={true}
        onDataStateChange={dataStateChange}
        {...dataState}
        onExpandChange={expandChange}
          resizable={true} 
        columnVirtualization={false}
      >
        <GridColumn
          field="name"
          title="Name"
          columnMenu={ColumnMenu}
        />
        <GridColumn
          cell={CommandCell}
          title="Action"
          groupable={true}
        />
        <GridNoRecords>
          <div className="mt-2" style={{ width: "100%", height: "500px" }}>
            <center>
              <h5>No data found</h5>
            </center>
          </div>
        </GridNoRecords>
      </Grid>
    );
    if (isError) {
      return (
        <div>
          <h4>Error Loadong Page..</h4>
        </div>
      );
    }
    return (
      <>
        <div
          style={{ minHeight: "600px" }}
          className="card p-3 border-0 m-3 sw-shadow radius-15"
        >
          <div className="top-sec-align row">
            <div className="d-flex">
              {/* <div className="d-flex">
              
              </div> */}
              <h5 className="text-normal title-web mb-0">SALE TYPE</h5>

              <input
                type="text"
                className="form-control ms-auto search-right-align searchBg"
                placeholder="Search"

                onChange={onSearch}
              />
              <button
                title="Add new"
                className="btn btn-primary btn-sm ms-3  "
                onClick={() => {
                  setEditModal(true);
                  setEditdata(new SaleTypeModel());
                }}
                style={{ marginTop: "-5px" }} // Adjust the value as needed
              >
                Add Sale Type
              </button>

              <button
                title="Export Excel"
                className="export-button ms-2"
                onClick={excelExport}
                style={{ marginTop: "-5px" }}
              >
                Export to Excel
              </button>
              <button
                title="Refresh list"
                className="export-button ms-2"
                onClick={() => {
                  refreshGrid();
                }}
                style={{ marginTop: "-5px" }}
              >
                Refresh
              </button>
            </div>
          </div>
          <LoadingIndicator isLoading={isLoading} />
          {editModal && (
            <SaleTypeEntry data={editData} onClose={onSaveComplete} />
          )}
          {deleteSaleTypeData && (
            <DeleteModelDialog
              title="Delete SaleType"
              deleteData={deleteSaleTypeData}
              onClose={onDeleteComplete}
            >
              <div>
                Are you sure you want to delete SaleType :{" "}
                <span style={{ fontWeight: "bold" }}>
                  {deleteSaleTypeData.data.name}
                </span>
                ?
              </div>
            </DeleteModelDialog>
          )}

          <div>
            <>
              {grid}
              <ExcelExport
                fileName={"SaleType_List"}
                data={result}
                ref={exportExcel}
              >
                <ExcelExportColumn width={100} field="name" title=" Name" />
                <ExcelExportColumn width={150} field="union" title="Union" />
              </ExcelExport>
            </>
          </div>
          <div></div>
        </div>
      </>
    );
  }
};
export default SaleTypePage;
